import { Link, useNavigate } from "react-router-dom";
import { DeleteIcon, EllipsisVertical, Upload } from "lucide-react";
import { ListFilter, Search } from "lucide-react";
import { Badge } from "../../component/ui/badge";
import { Button } from "../../component/ui/button";
import { BsUpload } from "react-icons/bs";
import { FaRegEye } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import { IoIosArrowBack } from "react-icons/io";
import { useBreadCrumb } from "../../component/ui/breadcrumb";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu";
import { Input } from "../../component/ui/input";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../component/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../component/table/table";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../../component/ui/tabs";
import { useEffect, useState } from "react";
import DataTable2 from "../../component/table/dataTable2";
import { InvestorInfo } from "../distributorPage/InvestorInfo";
import { viewIcon } from "../../assets/icons";
import { MdFileUpload, MdOutlineDelete, MdOutlineModeEdit } from "react-icons/md";
import { deleteInvestor, getAllInvestorDetails, getAllInvestorDetailsAssignedToEmployeeByScheme, getAllInvestorDetailsByScheme, getInvestorInfo } from "../../utils/util";
import Datatable3 from "../../component/table/datatable3";
import { loaderSet } from '../../context/actions/loaderAction';
import { useDispatch, useSelector } from 'react-redux';
import { alertDanger, alertSuccess, alertWarning } from "../../context/actions/toastAction";
import { setInvestorInfo } from "../../context/actions/investorInfoAction";
import AdvancedDropdown from "../../component/ui/multi-selection-dropdown-menu-with-search";
import { setSchemeInfoDetailsAgainstInvestor } from "../../context/actions/schemeInfoAgainstInvestorAction";


function Investors({employee}) {
  const dispatch = useDispatch();
const [investorInfoComponent,setInvestorInfoComponent]=useState(false)
// Show loader
useEffect(()=>{
  dispatch(loaderSet(true));
  // dispatch(alertSuccess("Hii Sekar"))
  setInterval(() => {
    dispatch(loaderSet(false))
  }, 2000);

},[])

// Hide loader after some async operation
// dispatch(loaderSet(false));
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState("");
  const [investorInfoId ,setInvestorInfoId]=useState()
  const [allInvestor,setAllInvestor]=useState([])
  const [currentPage,setCurrentPage]=useState(1)
const [totalPage,setTotalPage]=useState(1)
const [selectedSchemeOptions, setSelectedSchemeOptions] = useState([]);
const [schemeAndClassOption, setSchemeAndClassOption] = useState([]);
const allSchemeDetails=useSelector(state=>state.allSchemeDetails)

useEffect(() => {
  console.log("allSchemeDetails:", allSchemeDetails);
  if (allSchemeDetails && allSchemeDetails?.length > 0) {
    console.log("allSchemeDetails.schemes:", allSchemeDetails.schemes);
    const schemeAndClass = allSchemeDetails.flatMap((item) => {
      console.log("item:", item);
      if (Array.isArray(item.scheme_class)) {
        return item.scheme_class.map((schemeClass) => `${item.scheme_name}-${schemeClass}`);
      }
      return [];
    });
    console.log("schemeAndClass:", schemeAndClass);
    setSchemeAndClassOption(schemeAndClass);
    if(schemeAndClass?.length>0){
      setSelectedSchemeOptions([schemeAndClass[0]])
    }
  }
}, [allSchemeDetails]);


  const handleInvestorInfoId=async(data)=>{
    console.log("handleInvestorInfoId",data)
    if(data){
      const payload={
        user_email: data.user_email
        ,
        user_type: data.user_type,
        user_id: data.user_id
      }
      try {
        if(!employee)
        {
           const response=await getInvestorInfo(payload)
            if( response && response?.code!==200){
                     dispatch(alertDanger("Internal Server Error"))
                    //  setIsLoading(false)
                     return
                   }
        dispatch(setInvestorInfo(response))
        setInvestorInfoId(data.user_id)
        setInvestorInfoComponent(true)
           return
        }
       
      console.log("response for handleInvestorInfoId",data)
      if(data){
        dispatch(setInvestorInfo(data))
        dispatch(setSchemeInfoDetailsAgainstInvestor(data?.schemes))
        setInvestorInfoId(data.user_id)
        setInvestorInfoComponent(true)
    //     const response=await getInvestorInfo(payload)
    //     if( response && response?.code!==200){
    //              dispatch(alertDanger("Internal Server Error"))
    //             //  setIsLoading(false)
    //              return
    //            }
    //    dispatch(setInvestorInfo(response))
    // setInvestorInfoId(data.user_id)
    // setInvestorInfoComponent(true)
    //    return
      }
      else{
        dispatch(alertDanger("Internal Server Error"))
        return
      }
      } catch (error) {
        console.log("Error in handleInvestorInfoId function ",error)
      }
    }
  }
  const handleDeleteInvestor=async()=>{
    const payload={
      "user_id":"user_456186b2",
      "user_email":"madhankumarraja6@gmail.com",
      "user_type":"employee"
    }
    try {
      const response =await deleteInvestor(payload)
      console.log("response")
    } catch (error) {
      console.log("Error in delete api ",error)
    }
  }
  const buttonOptions = [
 
    {
      name:"Delete",
      text: <span className="text-base font-semibold">Delete</span>,
      // action:()=>{},
      icon:<MdOutlineDelete size={20} />,
      actionDandleDeleteInvestor:handleDeleteInvestor
      },
      {
        name:"View",
        text: <span className="text-base font-semibold">View</span>,
      //  action:handleInvestorInfoId(selectedId),
        icon:<FaRegEye size={20} />
        },
        {
          name:"Edit",
          text: <span className="text-base font-semibold">Edit</span>,
          icon:<MdOutlineModeEdit size={20} />,
          // action:()=>{},
        }
  ];
  const { selectedTab, setSelectedSubTab } = useBreadCrumb();
  const [investorDetails,setInvestorDetails]=useState([])
  const investorListData = [
    {
      id: 121,
      investorName: "Rohit Shah",
      investmentDate: "29-01-2020",
      otherDetails: "India",
    },
    {
      id: 122,
      investorName: "Jack Smith",
      investmentDate: "15-06-2021",
      otherDetails: "USA",
    },
    {
      id: 123,
      investorName: "John Doe",
      investmentDate: "09-03-2022",
      otherDetails: "Australia",
    },
  ];

  const columns = [
    { id: 'name', header: ' Name' },
    { id: 'user_email', header: 'Email' },
    { id: 'mobile_number', header: 'Phone No' },
    // { id: 'scheme', header: 'Scheme' },
    // { id: 'class', header: 'Class' },
  ];

  const tabsList = [
    {
      label: "Dashboard",
      value: "dashboard",
      component: <h1>Dashboard Tab</h1>,
    },
    { label: "Reports", value: "reports", component: <h1>Reports Tab</h1> },
  ];

  const employeeInfo=useSelector(state=>state.employeeInfo)

const getAllInvestor=async()=>{
let scheme_name,scheme_class
if(selectedSchemeOptions && selectedSchemeOptions?.length>0){
  scheme_class = selectedSchemeOptions[0]?.split("-")[1] 
 scheme_name =selectedSchemeOptions[0]?.split("-")[0] 
          

}

  const payload={
    scheme_class:scheme_class,
    scheme_name:scheme_name,
    page_no : currentPage,
     per_page :10,
      user_type:employeeInfo && employee ? "employee" : "investor",
      user_id:employeeInfo && employee ? employeeInfo?.user_id : ""
  }
  try {
    let response;
    if (!employee && !employeeInfo && selectedSchemeOptions?.length>0) {
      response = await getAllInvestorDetailsByScheme(payload);
    } else if (employee && employeeInfo && selectedSchemeOptions?.length>0) {
      response = await getAllInvestorDetailsAssignedToEmployeeByScheme(payload);
    }
    if(response && selectedSchemeOptions?.length>0 ){
      if(response?.code===200)
      {

        console.log("investor",response)
        // dispatch(alertSuccess(response.message))
        setInvestorDetails(response?.data.investors)
        setTotalPage(response.data.pagination.total_pages)
      }
      else{
      
        dispatch(alertDanger(response?.message))
        setInvestorDetails([])
        setTotalPage(1)
      }
    }
    else{
      setInvestorDetails([])
      setTotalPage(1)
    }
  } catch (error) {
    setInvestorDetails([])
    setTotalPage(1)
    console.log("Error in get investor api",error)
  }
}
useEffect(()=>{
getAllInvestor();
},[currentPage,selectedSchemeOptions,employeeInfo])



// const investorDetailsForTable=employeeInfo && employee ? employeeInfo.investors :investorDetails
const investorDetailsForTable=investorDetails

const[searchTerm,setSearchTerm]=useState("")

const [filteredSchemes,setFilteredSchemes] = useState([])

useEffect(()=>{
console.log(searchTerm)
if(searchTerm.length>0){
setFilteredSchemes(investorDetailsForTable.filter((investor) => {
  const search = searchTerm.toLowerCase();
  return (
      investor.user_email.toLowerCase().includes(search) ||
      investor.name.toLowerCase().includes(search) ||
      investor.mobile_number.toString().toLowerCase().includes(search) 
      
  );
}))
}
else{
setFilteredSchemes(investorDetailsForTable)
}

},[searchTerm,investorDetailsForTable])


  return (
    <>
    <main className="flex-1 h-screen overflow-y-auto p-4">
            {/* Conditionally render components based on selected tab */}
            {/* {selectedTab === "Dashboard" && <Dashboard />} */}
           
            { !investorInfoComponent  ?
          <>
            <div className="w-full flex justify-between items-start p-2 bg-[#FFFFFF] rounded-md">
            <div className="flex w-full justify-end items-center gap-4">
            <div className="w-64 h-10">
                <AdvancedDropdown
                  name="Scheme"
                  id="scheme"
                  options={schemeAndClassOption}
                  selectedOptions={selectedSchemeOptions}
                  setSelectedOptions={setSelectedSchemeOptions}
                  placeholder="Scheme"
                  select={"single"}
                  label={false}
                />
              </div>
              
              {/* Search Bar */}
              <div className="flex w-96 gap-2 border-b-2 border-[#0D215C]">
              <Search className="h-8 w-6 text-muted-foreground" />
                        <Input
                            type="search"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e)=>setSearchTerm(e.target.value)}
                            className="rounded-none border-none focus:ring-0 text-lg"
                        />
              </div>

              <div className="flex  gap-2  ">
               
               
                <Button onClick={()=>navigate(!employee ? "/admin/investor-upload-report": "/employee/investor-upload-report")} variant="outline" size="sm" className="h-7 gap-1 text-sm">
                <MdFileUpload  className="h-3.5 w-3.5"  />
                      <span className="sr-only sm:not-sr-only">Upload</span>
                    </Button>
              </div>
          
              {/* Dropdown Menu */}
              {/* <div className="flex items-center gap-2">
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="outline" size="sm" className="h-7 gap-1 text-sm">
                      <ListFilter className="h-3.5 w-3.5" />
                      <span className="sr-only sm:not-sr-only">Filter</span>
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuLabel>Filter by</DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    <DropdownMenuCheckboxItem checked>Fulfilled</DropdownMenuCheckboxItem>
                    <DropdownMenuCheckboxItem>Declined</DropdownMenuCheckboxItem>
                    <DropdownMenuCheckboxItem>Refunded</DropdownMenuCheckboxItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div> */}
            </div>
          </div>
          
                        
           <div className="w-full bg-[#FFFFFF] mt-4 rounded-md " > 
            <Datatable3 totalPage={totalPage} currentPage={currentPage} setCurrentPage={setCurrentPage} columns={columns} user_type={"investor"} 
          //  data={investorDetailsForTable} 
          data={filteredSchemes}
           
           onRowClick={handleInvestorInfoId} /> </div>
           </>
        : <InvestorInfo forWhichUserType={ employee ? "employee" : "admin"} back={()=>setInvestorInfoComponent(false)} />  }
          </main>
    </>
  )
}

export default Investors;
